<template>
    <form id="lead-on-login-form" @submit.prevent="onSave">
        <div v-if="error" class="alert alert-danger">
            {{ error }}
        </div>
        <div v-if="message" class="alert alert-success">
            {{ message }}
        </div>
        <div class="form-group">
            <label for="name">
                Navn
            </label>
            <input
                id="name"
                v-model="model.name"
                type="text"
                class="form-control"
                name="name"
                required="required"
            />
        </div>
        <div class="form-group">
            <label for="dknr">
                DKnr.
            </label>
            <input
                id="dknr"
                v-model="model.dknr"
                type="text"
                class="form-control"
                name="dknr"
                required="required"
            />
        </div>
        <div class="form-group">
            <label for="type">
                Type
            </label>
            <select
                id="type"
                v-model="model.type"
                class="form-control"
                name="type"
            >
                <option disabled value="">Vælg venligst</option>
                <option value="1">Privat</option>
                <option value="2">Erhverv</option>
                <option value="3">Småkontakt</option>
            </select>
        </div>
        <div v-if="model.type == 1">
            <div class="form-group">
                <label for="cust_name">
                    Kundens navn
                </label>
                <input
                    id="cust_name"
                    v-model="model.cust_name"
                    type="text"
                    class="form-control"
                    name="cust_name"
                    required="required"
                />
            </div>
            <div class="form-group">
                <label for="cust_phone">
                    Tlf nr.
                </label>
                <input
                    id="cust_phone"
                    v-model="model.cust_phone"
                    type="text"
                    class="form-control"
                    name="cust_phone"
                    required="required"
                />
            </div>
            <div class="form-group">
                <label for="cust_zipcode">
                    Post nr.
                </label>
                <input
                    id="cust_zipcode"
                    v-model="model.cust_zipcode"
                    type="text"
                    class="form-control"
                    name="cust_zipcode"
                    required="required"
                />
            </div>
            <div class="form-group">
                <label for="cust_comment">
                    Evt. kommentar
                </label>
                <textarea
                    id="cust_comment"
                    v-model="model.cust_comment"
                    class="form-control"
                    name="cust_comment"
                />
            </div>
        </div>
        <div v-if="model.type == 2">
            <div class="form-group">
                <label for="company_name">
                    Virksomhedsnavn
                </label>
                <input
                    id="company_name"
                    v-model="model.company_name"
                    type="text"
                    class="form-control"
                    name="company_name"
                    required="required"
                />
            </div>
            <div class="form-group">
                <label for="company_address">
                    Adresse
                </label>
                <input
                    id="company_address"
                    v-model="model.company_address"
                    type="text"
                    class="form-control"
                    name="company_address"
                />
            </div>
            <div class="form-group">
                <label for="company_zipcode">
                    Post nr.
                </label>
                <input
                    id="company_zipcode"
                    v-model="model.company_zipcode"
                    type="text"
                    class="form-control"
                    name="company_zipcode"
                    required="required"
                />
            </div>
            <div class="form-group">
                <label for="company_city">
                    By
                </label>
                <input
                    id="company_city"
                    v-model="model.company_city"
                    type="text"
                    class="form-control"
                    name="company_city"
                    required="required"
                />
            </div>
            <div class="form-group">
                <label for="company_phone">
                    Telefon nr.
                </label>
                <input
                    id="company_phone"
                    v-model="model.company_phone"
                    type="text"
                    class="form-control"
                    name="company_phone"
                    required="required"
                />
            </div>
            <div class="form-group">
                <label for="company_contact">
                    Kontakt person
                </label>
                <input
                    id="company_contact"
                    v-model="model.company_contact"
                    type="text"
                    class="form-control"
                    name="company_contact"
                    required="required"
                />
            </div>
            <div class="form-group">
                <label for="company_comment">
                    Evt. kommentar
                </label>
                <textarea
                    id="company_comment"
                    v-model="model.company_comment"
                    class="form-control"
                    name="company_comment"
                    required="required"
                />
            </div>
        </div>
        <div v-if="model.type == 3">
            <div class="form-group">
                <label for="small_nr">
                    Anlægsnr.
                </label>
                <input
                    id="small_nr"
                    v-model="model.small_nr"
                    type="text"
                    class="form-control"
                    name="small_nr"
                />
            </div>
            <div class="form-group">
                <label for="small_text">
                    Hvilken opgave er udført
                </label>
                <textarea
                    id="small_text"
                    v-model="model.small_text"
                    class="form-control"
                    name="small_text"
                />
            </div>
        </div>
        <div class="form-group">
            <div>
                <button
                    type="submit"
                    class="btn btn-success btn-lg"
                    :disabled="saving"
                >
                    Send
                </button>
            </div>
        </div>
    </form>
</template>
<script>
export default {
    data() {
        return {
            model: {},
            message: "",
            error: "",
            saving: false
        };
    },
    methods: {
        onSave: function() {
            this.message = "";
            this.error = "";
            this.saving = true;
            axios
                .post("/leads/login", this.model)
                .then(
                    res => {
                        this.model = {};
                        this.message = "Dit kundeemne er modtaget";
                    },
                    error => {
                        this.error =
                            "Noget gik galt, er du sikker på at du udfyldte formen korrekt?";
                    }
                )
                .catch(() => {
                    this.error =
                        "Noget gik galt, er du sikker på at du udfyldte formen korrekt?";
                })
                .finally(() => (this.saving = false));
        }
    }
};
</script>
<style scoped>
.form-control {
    margin-top: 10px;
}
</style>
